.container {
  border-radius: var(--border-radius-medium);
  background-clip: content-box, border-box;
  background-origin: border-box;
  border: 1px solid transparent !important;
  background-image: linear-gradient(var(--app-background), var(--app-background)),
    radial-gradient(circle at top left, var(--color-primary), var(--color-error));
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.content {
  padding: 3.2rem;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 3.2rem;
  margin-top: 3.2rem;
}

.card {
  h3 {
    font-size: 1.6rem;
  }

  p {
    font-size: 1.4rem;
    margin-top: 1.2rem;
    line-height: 1.9rem;
    font-weight: 300;
    color: var(--text-color-white);
  }
}
